export enum Types {
  Initial = 'INITIALIZE',
  Logout = 'LOGOUT',
  LoginWithPassword = 'LOGIN_WITH_PASSWORD',
  LoginWithCode = 'LOGIN_WITH_CODE',
}
